import { ApiClient } from "./clients";
import { Collection } from "./models/common/Collection";
import { OverdueEvent } from "./models/overdue/OverdueEvent";

export class OverdueEventProvider {
  constructor(private readonly apiClient: ApiClient) {}

  getList(projectUuid: string): Promise<Collection<OverdueEvent>> {
    return this.apiClient.get(`/${projectUuid}/overdue-event`);
  }
}
